const mode = {
  MANUAL: 'Manual',
  CMP: 'CMP'
}

export default mode
